enum InvoiceStatus {
  PENDIENTE = 'Pendiente',
  FACTURA_INGRESADA = 'Factura Ingresada',
  FACTURA_DESCARGADA = 'Factura Descargada - Enviada a analizar',
  FACTURA_IMPUTADA = 'Factura imputada en la compañia',
  FACTURA_INCONVENIENTES = 'Factura con inconvenientes',
  RECHAZADA = 'Rechazada - Comuníquese con Contaduría',
}

export const getInvoiceStatusColors = (status: string): string => {
  switch (status) {
    case InvoiceStatus.PENDIENTE:
      return 'orange';
    case InvoiceStatus.FACTURA_INGRESADA:
      return 'green';
    case InvoiceStatus.FACTURA_DESCARGADA:
      return 'green';
    case InvoiceStatus.FACTURA_IMPUTADA:
      return 'geekblue';
    case InvoiceStatus.FACTURA_INCONVENIENTES:
      return 'volcano';
    case InvoiceStatus.RECHAZADA:
      return 'red';
    default:
      return '';
  }
};
